<template>
  <span>
    <div class="selectUserAuthorityStyle">
      <v-select
        v-model="selectData"
        item-text="label"
        item-value="value"
        :items="items"
        dense
        outlined
        return-object
        class="original-selectbox"
        hide-details
        :placeholder="$t('common.input_unselected_2')"
        :disabled="isDisabled"
        :height="height"
      >
      </v-select>
    </div>

    <span v-if="authorityDialog">
      <AuthorityChange
        v-model="authorityDialog"
        @change="changeAuthority"
        @cancel="cancelChangeAuthority"
      />
    </span>
  </span>
</template>

<script>
import { masterUtil } from '@/util'
import AuthorityChange from '@/components/layouts/Dialogs/AuthorityChange'

export default {
  components: {
    AuthorityChange
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    isDisabled: { default: false },
    height: { default: '32px' },
    check: { default: false }
  },
  data: () => ({
    items: [],
    newValue: {},
    oldValue: {},
    authorityDialog: false,
    selectData: {}
  }),
  created() {
    this.init()
  },
  methods: {
    init() {
      this.items = masterUtil.getAuthorityList()
      this.selectData = this.value
    },
    changeAuthority() {
      this.authorityDialog = false
      this.$emit('change', this.selectData)
    },
    cancelChangeAuthority() {
      this.selectData = this.oldValue
      this.authorityDialog = false
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    selectData: {
      deep: true,
      handler(newVal, oldVal) {
        if (
          Object.keys(oldVal).length > 0 &&
          newVal.value !== this.value.value
        ) {
          this.newValue = newVal
          this.oldValue = oldVal

          if (this.check) {
            this.authorityDialog = true
          } else {
            this.changeAuthority()
          }
        }
      }
    },
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectUserAuthorityStyle {
  width: 125px;
}
</style>
